import { ItemErpItemNumbers } from '../models';

export function getErpItemNumber(item: ItemErpItemNumbers | null): string | null {
  if (item == null) return null;
  return (
    (Object.entries(item) as [keyof ItemErpItemNumbers, string][]).reduce<string | null>((acc, [, value]) => {
      if (acc !== null) return acc;
      if (value !== undefined && value !== null && value.trim() !== '') {
        return value;
      }
      return null;
    }, null) ?? null
  );
}
